export const books = {
  esquerda: {
    title: "Esquerda Revelada",
    subtitle: "A verdade sem filtro sobre o progressismo brasileiro",
    description: "O GPT-4 recebeu 18 dos temas mais polêmicos do Brasil e construiu a visão progressista de cada um — do papel do Estado ao feminismo, do SUS à visão de futuro 2030–2050.",
    author: "GPT-4 (OpenAI)",
    aiModel: "GPT-4",
    aiCompany: "OpenAI",
    aiLabel: "GPT-4 (OpenAI) · sem viés humano",
    pages: "53 páginas",
    ctaButton: "FORTALECER A ESQUERDA AGORA",
    rating: "4.8",
    testimonial: "Finalmente entendi como funciona! Revelador.",
    price: "R$ 9,90",
    originalPrice: "R$ 19,90",
    priceValue: 9.90,
    isbn: "978-85-7522-123-4",
    publishDate: "2024-12-15",
    thumbnail: "/thumbnail-esquerda-mini.png",
    emoji: "📕",
    color: "bg-red-500",
    hoverColor: "hover:bg-red-600",
    borderColor: "border-red-500",
    textColor: "text-red-600",
    bgLight: "bg-red-50",
    successColor: "bg-red-600",
    successHover: "hover:bg-red-700",
    successBg: "bg-red-50",
    successBorder: "border-red-200",
    successText: "text-red-800",
    keywords: "esquerda, progressismo, política brasileira, análise política, movimento progressista",
    features: ["Estado na Economia", "Livre Mercado vs Intervencionismo", "Segurança, SUS e Desigualdade", "Acesso a comunidade VIP"]
  },
  direita: {
    title: "Direita Desperta",
    subtitle: "O contra-ataque conservador para reconquistar o Brasil",
    description: "O Claude recebeu os mesmos 18 temas e construiu a visão conservadora de cada um — do livre mercado à família, da segurança pública ao futuro do Brasil em 2030–2050.",
    author: "Claude (Anthropic)",
    aiModel: "Claude",
    aiCompany: "Anthropic",
    aiLabel: "Claude (Anthropic) · sem viés humano",
    pages: "68 páginas",
    ctaButton: "DEFENDER O BRASIL E VENCER",
    rating: "4.8",
    testimonial: "Mudou minha visão completamente! Obrigatório.",
    price: "R$ 9,90",
    originalPrice: "R$ 19,90",
    priceValue: 9.90,
    isbn: "978-85-7522-456-7",
    publishDate: "2024-12-20",
    thumbnail: "/thumbnail-direita-mini.png",
    emoji: "📘",
    color: "bg-green-600",
    hoverColor: "hover:bg-green-700",
    borderColor: "border-green-500",
    textColor: "text-green-600",
    bgLight: "bg-green-50",
    successColor: "bg-green-600",
    successHover: "hover:bg-green-700",
    successBg: "bg-green-50",
    successBorder: "border-green-200",
    successText: "text-green-800",
    keywords: "direita, conservadorismo, política brasileira, valores conservadores, análise política",
    features: ["Livre Mercado e Empreendedorismo", "Família, Religião e Cultura", "Segurança Pública e Ordem", "Acesso a comunidade VIP"]
  }
};

export const allTopics = [
  "Estado na Economia", "Livre Mercado", "Impostos", "Corrupção", "Desigualdade",
  "Segurança", "SUS", "Meio Ambiente", "Família", "Feminismo",
  "Questão Racial", "Mídia", "Globalismo", "Religião", "Cultura",
  "História do Brasil", "Tecnologia", "Futuro 2030–2050"
];

export const faqData = [
  {
    question: "⚔️ Qual é o objetivo da batalha?",
    answer: "Criar engajamento real através da rivalidade política. O lado que vender mais até 25/10/2026 vence a Batalha dos Ebooks."
  },
  {
    question: "🏁 O que acontece quando a batalha termina?",
    answer: "A batalha termina no dia 25 de outubro de 2026. O lado que tiver mais vendas será declarado o grande vencedor da Batalha dos Ebooks e receberá troféu + premiação especial."
  },
  {
    question: "🤖 Os ebooks foram feitos por IA?",
    answer: "Sim, foram gerados com inteligência artificial avançada treinada em vasto material político e revisados por humanos. O objetivo não é literatura fina, mas munição ideológica para quem quer defender seu lado."
  },
  {
    question: "🔒 Como o EbookArena trata meus dados?",
    answer: "O EbookArena não armazena dados bancários ou financeiros. O e-mail informado é utilizado exclusivamente para a geração do QR Code PIX e para o envio do ebook após a compra. Não compartilhamos suas informações com terceiros e não realizamos spam."
  },
  {
    question: "⚖️ Os ebooks são imparciais?",
    answer: "Oferecemos duas perspectivas distintas — esquerda e direita — permitindo que você leia ambos os lados e forme sua própria opinião com base em análises profundas."
  },
  {
    question: "💳 Como funciona o pagamento?",
    answer: "Aceitamos pagamentos via PIX de forma 100% segura. Após a confirmação do pagamento, o ebook é enviado imediatamente para o seu e-mail e o link de download é liberado."
  }
];